import { css } from 'styled-components';

export const pxToRem = (px: number) => css`
  ${({ theme }) => theme.typography.pxToRem(px)}
`;

export const pxToStatic19Rem = (px: number) => `${px / 19}rem`;
